import { Toolbar } from "ngx-editor";

export const APP_CONSTANTS = {
    URL_REGEX: '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,20})[/\\w .\\-=_\\?&]*',
    EDITOR_TOOLBAR: [
        ["bold", "italic", "underline", "strike", "bullet_list", "ordered_list","text_color", "superscript", "subscript", "format_clear", { heading: ['h1', 'h2', 'h3'] }]
    ] as Toolbar,
}